var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canUngroup && !_vm.readOnly)?_c('span',{staticClass:"ungroup-need",attrs:{"title":"Remove need from the group"},on:{"click":_vm.ungroup}},[_c('i',{staticClass:"fas fa-fw fa-times"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }